import { createApp } from 'vue';
import ChatApp from './ChatApp.vue';

/**
 * AIノウハウチャットを初期化
 * @param {string} elementId - マウントする要素のID
 * @param {object} props - ChatAppに渡すprops
 */
export function initAiKnowhowChat(elementId, props = {}) {
  const el = document.getElementById(elementId);
  if (!el) {
    console.error(`[ai-knowhow] Element #${elementId} not found`);
    return null;
  }

  const app = createApp(ChatApp, props);
  app.mount(`#${elementId}`);
  return app;
}

if (typeof window !== 'undefined') {
  window.initAiKnowhowChat = initAiKnowhowChat;
}
